import { toast } from 'react-toastify';
import { convertPageableResponse } from '../../utils/responseMapper';
import * as api from '../api/clientsApi';
import * as types from '../constants/clientsConstants';

export const getClientsActions = (search, unpaged) => async (dispatch) => {
  dispatch({ type: types.GET_CLIENTS_REQUEST });
  try {
    const { error, data } = await api.getClients(search, unpaged);
    if (error) {
      throw new Error(error);
    }

    const { content, ...paginationData } = data;
    const pageable = convertPageableResponse(paginationData);

    dispatch({
      type: types.GET_CLIENTS_SUCCESS,
      payload: {
        data: content,
        pageable: pageable,
      },
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список клієнтів');
    dispatch({ type: types.GET_CLIENTS_FAILURE });
  }
};

export const getClientVehiclesAction = (clientId) => async (dispatch) => {
  dispatch({ type: types.GET_CLIENT_VEHICLES_REQUEST });
  try {
    const { error, data } = await api.getClient(clientId);
    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_CLIENT_VEHICLES_SUCCESS,
      payload: data.vehicles,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список автомобілів клієнта');
    dispatch({ type: types.GET_CLIENT_VEHICLES_FAILURE });
  }
};

export const createClientAction = (client) => async () => {
  try {
    const { error } = await api.createClient(client);
    if (error) {
      throw new Error(error);
    }
    toast.success('Клієнт був успішно доданий');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати нового клієнта');
  }
};

export const updateClientAction = (client) => async () => {
  try {
    const { error } = await api.updateClient(client);
    if (error) {
      throw new Error(error);
    }
    toast.success('Інформація клієнта була успішно змінена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити інформацію клієнта');
  }
};

export const clearClientsAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_CLIENTS,
  });
};

export const clearClientVehiclesAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_CLIENT_VEHICLES,
  });
};

export const setClientsPageSizeAction = (pageSize) => async (dispatch) => {
  dispatch({
    type: types.SET_CLIENTS_PAGE_SIZE,
    payload: pageSize,
  });
};

export const setSelectedClientAction = (client) => async (dispatch) => {
  dispatch({
    type: types.SELECT_CLIENT,
    payload: client,
  });
};

export const clearSelectedClientAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_CLIENT,
  });
};

export const setClientsSearchAction = (search) => async (dispatch) => {
  dispatch({
    type: types.SET_CLIENTS_SEARCH,
    payload: search,
  });
};

export const nextClientsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.NEXT_CLIENTS_PAGE,
  });
};

export const prevClientsPageAction = () => async (dispatch) => {
  dispatch({
    type: types.PREV_CLIENTS_PAGE,
  });
};
